export const BREAKPOINTS = {
  MEDIUM: 500,
};
